import { render, staticRenderFns } from "./remnantOrder3.vue?vue&type=template&id=4e8cc3ee&scoped=true&"
import script from "./remnantOrder3.vue?vue&type=script&lang=js&"
export * from "./remnantOrder3.vue?vue&type=script&lang=js&"
import style0 from "./remnantOrder3.vue?vue&type=style&index=0&id=4e8cc3ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8cc3ee",
  null
  
)

export default component.exports